module.exports = __webpack_public_path__ + "media/fonts/CircularStd-Bold-544334209f41ff0b1ebb37057a9cab48.ttf";